import { render, staticRenderFns } from "./AisleCopyCreate.vue?vue&type=template&id=33dceaad&scoped=true"
import script from "./AisleCopyCreate.vue?vue&type=script&lang=js"
export * from "./AisleCopyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dceaad",
  null
  
)

export default component.exports